var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSenseifiIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    x: "0px",
    y: "0px",
    width: "1080px",
    height: "1080px",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_1",
    gradientUnits: "userSpaceOnUse",
    x1: 434.925,
    y1: 329.48749999999995,
    x2: 397.075,
    y2: 285.3125,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_2",
    gradientUnits: "userSpaceOnUse",
    x1: 433.0375,
    y1: 214.1875,
    x2: 450.6625,
    y2: 158.5125,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_3",
    gradientUnits: "userSpaceOnUse",
    x1: 316.3,
    y1: 432.9,
    x2: 355.09999999999997,
    y2: 468,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_4",
    gradientUnits: "userSpaceOnUse",
    x1: 324.425,
    y1: 552.8625,
    x2: 302.575,
    y2: 592.1375,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_5",
    gradientUnits: "userSpaceOnUse",
    x1: 203.4,
    y1: 330.5,
    x2: 170.1,
    y2: 305.79999999999995,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_6",
    gradientUnits: "userSpaceOnUse",
    x1: 426.6375,
    y1: 438.9125,
    x2: 470.8625,
    y2: 394.6875,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_7",
    gradientUnits: "userSpaceOnUse",
    x1: 321.1125,
    y1: 319.6875,
    x2: 290.58750000000003,
    y2: 350.2125,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_8",
    gradientUnits: "userSpaceOnUse",
    x1: 545.35,
    y1: 428.0625,
    x2: 588.65,
    y2: 448.5375,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_9",
    gradientUnits: "userSpaceOnUse",
    x1: 290.75,
    y1: 712.45,
    x2: 308.54999999999995,
    y2: 688.45,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFEB63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_10",
    gradientUnits: "userSpaceOnUse",
    x1: 17.862499999999997,
    y1: 368.1875,
    x2: 65.9375,
    y2: 374.3125,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFEB63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_11",
    gradientUnits: "userSpaceOnUse",
    x1: 254.85,
    y1: 99.1125,
    x2: 293.65,
    y2: 112.28750000000001,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFEB63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_12",
    gradientUnits: "userSpaceOnUse",
    x1: 612.9499999999999,
    y1: 247.63750000000002,
    x2: 613.65,
    y2: 265.46250000000003,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFEB63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cross_0_Layer1_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_1)",
    stroke: "none",
    d: " M 376.65 344.35 L 408.95 376.65 489.15 296.4 457.05 264.3 376.65 183.95 296.45 264.15 376.65 344.35 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDB2C",
    stroke: "none",
    d: " M 376.65 113.55 Q 385.4154296875 113.55 392.3 118.05 L 477 41.2 Q 435.3 0 376.65 0 317.5 0 275.75 41.85 233.85 83.7 233.85 142.85 233.85 197.9 270.2 238 L 296.45 264.15 376.65 183.95 356.25 163.55 Q 356.15 163.45 356.05 163.35 347.5 154.8 347.5 142.75 347.5 130.65 356.05 122.1 364.55 113.55 376.65 113.55 M 376.65 569.25 L 397.05 589.65 Q 397.15 589.75 397.25 589.85 405.8 598.4 405.8 610.45 405.8 622.55 397.25 631.1 388.75 639.65 376.65 639.65 366.6048828125 639.65 359 633.7 L 279.45 715 Q 320.203125 753.2 376.65 753.2 435.8 753.2 477.55 711.35 519.45 669.5 519.45 610.35 519.45 555.3 483.1 515.2 L 456.85 489.05 376.65 569.25 M 113.55 376.6 Q 113.55 365.028515625 121.4 356.65 L 41.1 276.35 Q 0 318.0302734375 0 376.6 0 435.75 41.85 477.5 83.7 519.4 142.85 519.4 197.9 519.4 238 483.05 L 264.15 456.8 183.95 376.6 163.55 397 Q 163.45 397.1 163.35 397.2 154.8 405.75 142.75 405.75 130.65 405.75 122.1 397.2 113.55 388.7 113.55 376.6 M 753.3 376.6 Q 753.3 317.45 711.45 275.7 669.6 233.8 610.45 233.8 555.4 233.8 515.3 270.15 L 489.15 296.4 569.35 376.6 589.75 356.2 Q 589.85 356.1 589.95 356 598.5 347.45 610.55 347.45 622.65 347.45 631.2 356 639.75 364.5 639.75 376.6 639.75 386.4412109375 634.05 393.95 L 717.35 471.35 Q 753.3 431.3642578125 753.3 376.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_2)",
    stroke: "none",
    d: " M 477.65 41.85 Q 477.3310546875 41.5314453125 477 41.2 L 392.3 118.05 Q 394.9193359375 119.7693359375 397.25 122.1 405.8 130.65 405.8 142.75 405.8 154.8 397.25 163.35 397.05 163.55 396.85 163.75 L 376.65 183.95 457.05 264.3 481 240.3 Q 481.3 240 481.5 239.75 519.45 199.15 519.45 142.85 519.45 83.7 477.65 41.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_3)",
    stroke: "none",
    d: " M 264.15 456.8 L 296.85 489.5 376.65 569.25 456.85 489.05 377.3 409.4 344.4 376.6 264.15 456.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_4)",
    stroke: "none",
    d: " M 296.85 489.5 L 296.3 488.95 272.3 512.9 Q 272 513.2 271.8 513.45 233.85 554.05 233.85 610.35 233.85 669.5 275.65 711.35 277.530859375 713.2287109375 279.45 715 L 359 633.7 Q 357.47265625 632.52265625 356.05 631.1 347.5 622.55 347.5 610.45 347.5 598.4 356.05 589.85 356.25 589.65 356.45 589.45 L 376.65 569.25 296.85 489.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_5)",
    stroke: "none",
    d: " M 41.85 275.6 Q 41.474609375 275.9759765625 41.1 276.35 L 121.4 356.65 Q 121.760546875 356.339453125 122.1 356 130.65 347.45 142.75 347.45 154.8 347.45 163.35 356 163.55 356.2 163.75 356.4 L 183.95 376.6 263.75 296.8 264.3 296.25 240.3 272.25 Q 240 271.95 239.75 271.75 199.15 233.8 142.85 233.8 83.7 233.8 41.85 275.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_6)",
    stroke: "none",
    d: " M 569.35 376.6 L 489.15 296.4 408.95 376.65 376.7 408.75 377.3 409.4 456.85 489.05 489.55 456.35 569.35 376.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_7)",
    stroke: "none",
    d: " M 344.4 376.6 L 376.65 344.35 296.45 264.15 263.75 296.8 183.95 376.6 264.15 456.8 344.4 376.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_8)",
    stroke: "none",
    d: " M 711.45 477.6 Q 714.5203125 474.5259765625 717.35 471.35 L 634.05 393.95 Q 632.7671875 395.6328125 631.2 397.2 622.65 405.75 610.55 405.75 598.5 405.75 589.95 397.2 589.75 397 589.55 396.8 L 569.35 376.6 489.55 456.35 489 456.95 513 480.95 Q 513.3 481.25 513.55 481.45 554.15 519.4 610.45 519.4 669.6 519.4 711.45 477.6 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cross_0_Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_9)",
    stroke: "none",
    d: " M 275.65 711.35 Q 277.530859375 713.2287109375 279.45 715 320.203125 753.2 376.65 753.2 403.496484375 753.2 426.75 744.55 L 241.05 564.15 Q 233.85 585.765234375 233.85 610.35 233.85 669.5 275.65 711.35 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_10)",
    stroke: "none",
    d: " M 41.85 275.6 Q 41.474609375 275.9759765625 41.1 276.35 0 318.0302734375 0 376.6 0 435.75 41.85 477.5 68.172265625 503.8537109375 101.35 513.6 L 91.4 242.9 Q 64.1697265625 253.30703125 41.85 275.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_11)",
    stroke: "none",
    d: " M 275.75 41.85 Q 233.85 83.7 233.85 142.85 233.85 197.9 270.2 238 L 278.6 246.35 372.7 0.05 Q 316.0947265625 1.4087890625 275.75 41.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_12)",
    stroke: "none",
    d: " M 730.95 299.4 Q 722.71015625 286.933203125 711.45 275.7 669.6 233.8 610.45 233.8 555.4 233.8 515.3 270.15 L 498.6 286.9 730.95 299.4 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.33013916015625, 0, 0, 1.33013916015625, 39,39.05) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cross_0_Layer1_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cross_0_Layer0_0_FILL"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenseifiIcon);
export default __webpack_public_path__ + "static/media/senseifi-icon.a20b76688f5a76be657b1818acfbda3b.svg";
export { ForwardRef as ReactComponent };